(function () {
  if (!window.customElements || customElements.get('eve-card-media')) return;

  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var queue = [];
  var active = 0;
  var observer;

  function watch(card) {
    if (!finePointer.matches || card.hoverState === 'ready' || card.hoverState === 'failed') return;
    if (!window.IntersectionObserver) return;
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.hoverNear = entry.isIntersecting;
          if (entry.isIntersecting) prepare(entry.target, false);
        });
      }, { rootMargin: '180px 0px' });
    }
    observer.observe(card);
  }

  function prepare(card, intent) {
    if (!finePointer.matches || !card.querySelector('[data-eve-hover-image]')) return;
    if (card.hoverState && card.hoverState !== 'queued') return;
    if (card.hoverState === 'queued') {
      if (intent) {
        queue = queue.filter(function (item) { return item.card !== card; });
        queue.unshift({ card: card, intent: true });
      }
    } else {
      card.hoverState = 'queued';
      var item = { card: card, intent: intent };
      if (intent) queue.unshift(item);
      else queue.push(item);
    }
    drain();
  }

  function drain() {
    while (active < 2 && queue.length) {
      var item = queue.shift();
      var card = item.card;
      if (card.hoverState !== 'queued') continue;
      if (!finePointer.matches || !card.isConnected || (!item.intent && !card.hoverNear)) {
        card.hoverState = '';
        continue;
      }
      card.hoverState = 'loading';
      if (observer) observer.unobserve(card);
      active++;
      card.prepareSecondary().then(complete, complete);
    }
  }

  function complete() {
    active--;
    drain();
  }

  class EveCardMedia extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('[data-eve-hover-image]')) return;
      this.hoverSurface = this.closest('.card') || this;
      this.hoverSurface.addEventListener('pointerenter', this);
      watch(this);
    }

    disconnectedCallback() {
      this.hoverNear = false;
      if (this.hoverSurface) this.hoverSurface.removeEventListener('pointerenter', this);
      if (observer) observer.unobserve(this);
    }

    handleEvent(event) {
      if (event.pointerType !== 'touch') prepare(this, true);
    }

    prepareSecondary() {
      var card = this;
      var image = card.querySelector('[data-eve-hover-image]');
      image.loading = 'eager';
      var decoded;
      if (image.decode) {
        decoded = image.decode();
      } else {
        decoded = new Promise(function (resolve, reject) {
          if (image.complete) {
            if (image.naturalWidth) resolve();
            else reject();
            return;
          }
          function clean() {
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', failed);
          }
          function loaded() { clean(); resolve(); }
          function failed() { clean(); reject(); }
          image.addEventListener('load', loaded);
          image.addEventListener('error', failed);
        });
      }
      return decoded.then(function () {
        if (!image.naturalWidth) throw new Error('Image unavailable');
        card.hoverState = 'ready';
        card.setAttribute('data-eve-hover-ready', '');
      }).catch(function () {
        card.hoverState = 'failed';
      });
    }
  }

  customElements.define('eve-card-media', EveCardMedia);
  function pointerChanged() {
    if (!finePointer.matches) {
      if (observer) observer.disconnect();
      queue.forEach(function (item) { item.card.hoverState = ''; });
      queue = [];
      return;
    }
    document.querySelectorAll('eve-card-media').forEach(watch);
  }
  if (finePointer.addEventListener) finePointer.addEventListener('change', pointerChanged);
  else if (finePointer.addListener) finePointer.addListener(pointerChanged);
})();
